import { ActionButton, styled } from '@infra/ui-design-system'

export const StyledButton = styled(ActionButton)`
  display: flex;
  align-items: center;
  text-transform: none;
`
